import React from 'react'
import { ReactComponent as EditIcon } from '@jisr-hr/design-system/dist/assets/icons/edit.svg'
import { ReactComponent as FingerprintIcon } from './icons/fingerprint.svg'
import { ReactComponent as DeviceIcon } from './icons/device.svg'

export const punchIcons = {
  biometric: <FingerprintIcon />,
  geofencing: <DeviceIcon />,
  manual: <EditIcon />,
}

export const punchTypes = {
  in_punch: 'gray',
  out_punch: 'warning',
  in: 'gray',
  out: 'warning',
}
